import React, { useState } from "react";
import "../styles/Login.css";
import { Link, useNavigate } from "react-router-dom";
import { buildApiUrl, API_ENDPOINTS, APP_DISPLAY_NAME } from "../config/api";
import { apiRequest } from "../utils/apiUtils";
import { FiEye, FiEyeOff } from "react-icons/fi";
import PasswordStrengthChecklist from "../components/common/PasswordStrengthChecklist.jsx";

const Register = () => {
  const [name, setName] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [organization, setOrganization] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    password: "",
    privacy: "",
  });
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    let valid = true;
    let newErrors = { email: "", password: "", privacy: "" };

    if (email.trim() === "") {
      newErrors.email = "Por favor, ingresa tu email.";
      valid = false;
    }
    if (password.trim() === "") {
      newErrors.password = "Por favor, ingresa tu contraseña.";
      valid = false;
    }
    if (!privacyAccepted) {
      newErrors.privacy =
        "Debes aceptar la Política de Privacidad para continuar.";
      valid = false;
    }

    setErrors(newErrors);

    if (valid) {
      try {
        await apiRequest(buildApiUrl(API_ENDPOINTS.sessionRegister), {
          method: "POST",
          body: JSON.stringify({
            email,
            password,
            name,
            lastname,
            organization,
          }),
        });
        setShowSuccessModal(true);
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error("Error en la solicitud de register:", error);
        }
        alert(error.message || "Error al crear usuario. Intenta nuevamente.");
      }
    }
  };

  if (showSuccessModal) {
    return (
      <div className="login-page">
        <div className="login-card" style={{ textAlign: "center" }}>
          <div className="login-logo">
            <img src="/LOGOCETIUCLOGIN.png" alt={APP_DISPLAY_NAME} />
          </div>

          <div
            style={{ fontSize: "2.4rem", lineHeight: 1, margin: "4px 0 8px" }}
          >
            ✉️
          </div>

          <h2 className="login-title">¡Registro exitoso!</h2>

          <p className="login-subtitle">
            Tu solicitud de registro fue recibida. Un administrador revisará tu
            cuenta y te notificará por correo cuando esté aprobada. Revisá tu
            bandeja de entrada en los próximos días.
          </p>

          <button
            className="login-submit-btn"
            onClick={() => navigate("/login")}
            style={{ marginTop: "8px" }}
          >
            Ir al inicio de sesión
          </button>

          <div className="login-links-row">
            <a
              href="https://home.cetiuc.com/privacidad"
              target="_blank"
              rel="noopener noreferrer"
              className="login-secondary-link"
            >
              Privacidad de Datos
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src="/LOGOCETIUCLOGIN.png" alt={APP_DISPLAY_NAME} />
        </div>

        <h2 className="login-title">Crear Usuario</h2>

        <p className="login-subtitle">Completa los datos para registrarte.</p>

        <form onSubmit={handleRegister} className="login-form">
          <div className="login-field">
            <label htmlFor="reg-name">Nombre</label>
            <input
              id="reg-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Tu nombre"
              required
            />
          </div>

          <div className="login-field">
            <label htmlFor="reg-lastname">Apellido</label>
            <input
              id="reg-lastname"
              type="text"
              value={lastname}
              onChange={(e) => setLastname(e.target.value)}
              placeholder="Tu apellido"
              required
            />
          </div>

          <div className="login-field">
            <label htmlFor="reg-email">Correo electrónico</label>
            <input
              id="reg-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tunombre@mail.com"
            />
            {errors.email && (
              <span className="login-error">{errors.email}</span>
            )}
          </div>

          <div className="login-field">
            <label htmlFor="reg-password">Contraseña</label>
            <div className="login-password-wrapper">
              <input
                id="reg-password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Elige una contraseña"
              />
              <button
                type="button"
                className="login-eye-btn"
                onClick={() => setShowPassword((p) => !p)}
                tabIndex={-1}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
            {errors.password && (
              <span className="login-error">{errors.password}</span>
            )}
            <PasswordStrengthChecklist password={password} />
          </div>

          <div className="login-field">
            <label htmlFor="reg-organization">Organización</label>
            <input
              id="reg-organization"
              type="text"
              value={organization}
              onChange={(e) => setOrganization(e.target.value)}
              placeholder="Nombre de tu organización"
              required
            />
          </div>

          <div className="login-privacy-check">
            <label>
              <input
                type="checkbox"
                checked={privacyAccepted}
                onChange={(e) => setPrivacyAccepted(e.target.checked)}
              />
              Acepto la{" "}
              <a
                href="https://home.cetiuc.com/privacidad"
                target="_blank"
                rel="noopener noreferrer"
              >
                Política de Privacidad
              </a>
            </label>
            {errors.privacy && (
              <span className="login-error">{errors.privacy}</span>
            )}
          </div>

          <button type="submit" className="login-submit-btn">
            Registrarse
          </button>
        </form>

        <div className="login-links-row">
          <Link to="/login" className="login-secondary-link">
            ¿Ya tienes cuenta? <strong>Inicia sesión</strong>
          </Link>
          <a
            href="https://home.cetiuc.com/privacidad"
            target="_blank"
            rel="noopener noreferrer"
            className="login-secondary-link"
          >
            Privacidad de Datos
          </a>
        </div>
      </div>
    </div>
  );
};

export default Register;
